import { getCurrentDateTime } from '../../../helpers/date'

export const buildReports = (
  values,
  clientName,
  serviceName,
  campaignName,
  domainName,
  opsName,
  operationType
) => {
  return [
    {
      value: 1,
      label: 'Reported & removed links - per service',
      report_type: 'reported_removed_links_per_service',
      params: {
        customer: values.customer,
        service: values.service,
        start_date: values.start_date,
        end_date: values.end_date
      },
      name: `${clientName}_${values.start_date}__${values.end_date}_${getCurrentDateTime()}`
    },
    {
      value: 2,
      label: 'The none removed links - per service',
      report_type: 'reported_non_removed_links_per_service',
      params: {
        customer: values.customer,
        service: values.service,
        start_date: values.start_date,
        end_date: values.end_date
      },
      name: `${clientName}_${values.start_date}__${values.end_date}_${getCurrentDateTime()}`
    },
    {
      value: 3,
      label: 'Link not reported - per service',
      report_type: 'related_not_reported_links_per_service',
      params: {
        customer: values.customer,
        service: values.service
      },
      name: `${clientName}_links_not_reported_per_service_${getCurrentDateTime()}`
    },
    {
      value: 4,
      label: 'Top removed campaigns',
      report_type: 'top_removed_campaigns',
      params: {
        customer: values.customer,
        service: values.service,
        start_date: values.start_date,
        end_date: values.end_date
      },
      name: `${clientName}_${values.start_date}__${values.end_date}_${getCurrentDateTime()}`
    },
    {
      value: 5,
      label: 'Reported & removed links - per campaign',
      report_type: 'reported_removed_links_per_campaign',
      params: {
        customer: values.customer,
        service: values.service,
        campaign: values.campaign_name,
        start_date: values.start_date,
        end_date: values.end_date
      },
      name: `${clientName}_${values.start_date}__${values.end_date}_${getCurrentDateTime()}`
    },
    {
      value: 6,
      label: 'Number of link viewers - per service',
      report_type: 'number_of_viewers_per_service',
      params: {
        customer: values.customer,
        service: values.service,
        start_date: values.start_date,
        end_date: values.end_date
      },
      name: `${clientName}_Links_Views_${values.start_date}__${values.end_date}_${getCurrentDateTime()}`
    },
    {
      value: 7,
      label: 'Extract all active campaigns - per customer',
      report_type: 'active_campaigns_per_service',
      params: {
        customer: values.customer
      },
      name: `${clientName}_service_all_active_campaigns_${getCurrentDateTime()}`
    },
    {
      value: 8,
      label: 'Extract all UGC crawling domains in the system',
      report_type: 'all_ugc_crawling_domains',
      params: {},
      name: `ugc_crawling_domains_${getCurrentDateTime()}`
    },
    {
      value: 9,
      label: 'Extract Cyberlocker domain with reporting methods',
      report_type: 'all_cyber_lockers_domains_with_reporting_methods',
      params: {
        start_date: values.start_date,
        end_date: values.end_date
      },
      name: `Extract_Cyberlocker_domain_with_reporting_methods_${getCurrentDateTime()}`
    },
    {
      value: 10,
      label: 'Attached Services Per Customer/Campaign Report',
      report_type: 'attached_services_per_campaign',
      params: {
        customer: values.customer
      },
      name: `${clientName}_attached_services_per_campaign_${getCurrentDateTime()}`
    },
    {
      value: 11,
      label: 'Domain Links Status Report',
      report_type: 'per_domain',
      params: {
        customer: values.customer,
        service: values.service,
        campaign: values.campaign_name,
        domain: values.domain_id,
        start_date: values.start_date,
        end_date: values.end_date
      },
      name: `${clientName}_per_${domainName}_domain_links_report_${values.start_date}__${values.end_date}_${getCurrentDateTime()}`
    },
    {
      value: 12,
      label: 'Operation Team Performance Report',
      report_type: 'ops_performance',
      params: {
        service: values.service,
        campaign: values.campaign_name,
        start_date: values.start_date,
        end_date: values.end_date
      },
      name: `${opsName}_operation_team_report_${operationType}_${values.start_date}__${values.end_date}_${getCurrentDateTime()}`
    },
    {
      value: 13,
      label: 'Per Customer / Campaign - Crawling mode Report',
      report_type: 'per_customer_campaigns_mode',
      params: {
        customer: values.customer,
        start_date: values.start_date,
        end_date: values.end_date
      },
      name: `${clientName}_per_campaign_crawling_mode_report_${values.start_date}__${values.end_date}_${getCurrentDateTime()}`
    },
    {
      value: 14,
      label: 'Per Customer Top pirated domains',
      report_type: 'per_customer_top_pirated_domains',
      params: {
        customer: values.customer,
        start_date: values.start_date,
        end_date: values.end_date
      },
      name: `${clientName}_top_pirated_domains_report_${values.start_date}__${values.end_date}_${getCurrentDateTime()}`
    },
    {
      value: 15,
      label: 'Per Customer Inserted links',
      report_type: 'ops_performance',
      params: {
        operator_id: values.operator_id,
        campaign: '*',
        service: '*',
        operation_type: 'insertion',
        start_date: values.start_date,
        end_date: values.end_date
      },
      name: `${opsName}_inserted_links_report_${values.start_date}__${values.end_date}_${getCurrentDateTime()}`
    },
    {
      value: 16,
      label: 'Per Service - Customer - Campaign Reported/Removed [XLSX]',
      report_type: 'per_service_campaigns',
      params: {
        customer: values.customer,
        service: values.service,
        campaign: values.campaign_name,
        start_date: values.start_date,
        end_date: values.end_date
      },
      name: `${clientName}_client_per_${serviceName}_service_${campaignName}_campaign_reported_removed_${values.start_date}__${values.end_date}_${getCurrentDateTime()}`
    },
    {
      value: 17,
      label: 'Per Customer - Campaign Platform Summary',
      report_type: 'per_customer_campaign_service_summary',
      params: {
        customer: values.customer,
        campaign: values.campaign_name,
        start_date: values.start_date,
        end_date: values.end_date
      },
      name: `${clientName}_client_per_${campaignName}_campaign_Platform_Summary_${values.start_date}__${values.end_date}_${getCurrentDateTime()}`
    },
    {
      value: 19,
      label: 'Detected M3U Files',
      report_type: 'detected_m3u_files',
      params: {
        start_date: values.start_date,
        end_date: values.end_date
      },
      name: `Detected_M3U_Files_${values.start_date}__${values.end_date}_${getCurrentDateTime()}`
    },
    {
      value: 20,
      label: 'Reported M3U Links Per Customer',
      report_type: 'reported_m3u_links_per_customer',
      params: {
        customer: values.customer,
        start_date: values.start_date,
        end_date: values.end_date
      },
      name: `Reported_M3U_Links_Per_Customer_${clientName}_${values.start_date}__${values.end_date}_${getCurrentDateTime()}`
    },
    {
      value: 21,
      label: 'Monitoring Links',
      report_type: 'monitoring_links',
      params: {
        customer: values.customer,
        service: values.service,
        campaign: values.campaign_name,
        start_date: values.start_date,
        end_date: values.end_date
      },
      name: `${clientName}_${values.start_date}__${values.end_date}_monitoring_links_${getCurrentDateTime()}`
    },
    {
      value: 22,
      label: 'Blocking Domains Per Customer',
      report_type: 'blocking_domains_per_customer',
      params: {
        customer: values.customer,
        start_date: values.start_date,
        end_date: values.end_date
      },
      name: `${clientName}_${values.start_date}__${values.end_date}_blocking_domains_per_customer_${getCurrentDateTime()}`
    },
    {
      value: 25,
      label: 'IPTV Servers Status Report (Per Customer)',
      report_type: 'iptv_servers_status',
      params: {
        customer: values.customer,
        start_date: values.start_date,
        end_date: values.end_date
      },
      name: `${clientName}_iptv_servers_status_${values.start_date}__${values.end_date}_${getCurrentDateTime()}`
    },
    {
      value: 26,
      label: 'IPTV Reported Removed URLs',
      report_type: 'iptv_reported_removed_urls',
      params: {
        customer: values.customer,
        start_date: values.start_date,
        end_date: values.end_date
      },
      name: `${clientName}_iptv_reported_removed_urls_${values.start_date}__${values.end_date}_${getCurrentDateTime()}`
    },
    {
      value: 27,
      label: 'IPTV Active URLs',
      report_type: 'iptv_active_urls',
      params: {
        customer: values.customer,
        start_date: values.start_date,
        end_date: values.end_date
      },
      name: `${clientName}_iptv_active_urls_${values.start_date}__${values.end_date}_${getCurrentDateTime()}`
    },
    {
      value: 24,
      label: 'UGC Levels Reviewing Performance',
      report_type: 'ugc_review_report',
      params: {
        start_date: values.start_date,
        end_date: values.end_date,
        ugc_level: values.ugc_level,
        customer_id: values.customer || '',
        campaign_id: values.campaign_name || '',
        operator_id: values.operator_id || '*'
      },
      name: `ugc_reviewing_performance_${values.ugc_level}_${values.start_date}__${values.end_date}_${getCurrentDateTime()}`
    }
  ]
}
